"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _LearnMoreNZRequestSubmit_Mutation;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { Box, Stack, ToastProvider, useToast } from '@autoguru/overdrive';
import { useCallback, useState } from 'react';
import { HeadingSection } from '~/src/components/HeadingSection/HeadingSection';
import { graphql, useMutation } from 'react-relay/hooks';
import { LearnMoreForm } from '~/src/components/LearnMoreForm/LearnMoreForm';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RequestADemoComponent = ({
  size,
  isDesktop
}) => {
  const [learnMore, inFlight] = useMutation(_LearnMoreNZRequestSubmit_Mutation !== void 0 ? _LearnMoreNZRequestSubmit_Mutation : (_LearnMoreNZRequestSubmit_Mutation = require("../../../../../packages/relay/__generated__/LearnMoreNZRequestSubmit_Mutation.graphql"), _LearnMoreNZRequestSubmit_Mutation.hash && _LearnMoreNZRequestSubmit_Mutation.hash !== "3a33eea7ea075878a493985a0fe7f15d" && console.error("The definition of 'LearnMoreNZRequestSubmit_Mutation' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _LearnMoreNZRequestSubmit_Mutation));
  const toast = useToast();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const submitRequest = useCallback(variables => {
    learnMore({
      variables,
      onCompleted() {
        setIsFormSubmitted(true);
        toast.success('Thanks for submitting the form.');
      },
      onError() {
        toast.danger('Something went wrong');
      }
    });
  }, [learnMore, toast]);
  return /*#__PURE__*/_jsx(Box, {
    width: "full",
    id: "learn-more",
    paddingX: isDesktop ? '7' : 'none',
    children: /*#__PURE__*/_jsxs(Stack, {
      space: isDesktop ? '8' : '2',
      children: [/*#__PURE__*/_jsx(HeadingSection, {
        title: "Learn more",
        size: size
      }), /*#__PURE__*/_jsx(LearnMoreForm, {
        isFormSubmitted: isFormSubmitted,
        isLoading: inFlight,
        onSubmit: submitRequest
      })]
    })
  });
};
export const LearnMore = props => /*#__PURE__*/_jsx(ToastProvider, {
  children: /*#__PURE__*/_jsx(RequestADemoComponent, _objectSpread({}, props))
});